import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

/**
 * @author Jorge Nuñez López <>
 *
 * Get supplies to order
 * @return {Array}
 */

function transformer(data) {
  return {
    supplyId: data.supply,
    name: data.name,
    code: data.code,
    refQuantity: data.quantity,
    relatedConcepts: data.related_concepts,
    unitMeasurement: data.related_supplies_in_stock[0] ?
      data.related_supplies_in_stock[0].unit_measurement :
      null,
    inStock: data.related_supplies_in_stock[0] ?
      data.related_supplies_in_stock[0].in_stock :
      null,
  }
}

export default (affectedId) => {

  const request = Vue.$http.post(`purchase/preview-of-supplies-to-order/`, { affected: affectedId })
  return errorHandler(request)
    .then((response) => {
      const data = response.data.map(d => transformer(d))
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/fetchPreviewSupplies.js